export const NAME = 'agentReviewList'
